/**
 * 添加/编辑账号组件
 */

<template>
    <div id="addAccount">
        <Modal :value="addModal"
            :width="1000"
            :mask-closable="false"
            :closable="false"
            class-name="add-account"
        >
            <p slot="header">
                <slot></slot>
            </p>
            <!-- {{newAccount.province}}-{{newAccount.city}} -->
            <Spin fix v-if="ifSpin"></Spin>
            <Form ref="newAccount" :model="newAccount" :inline="true" label-position="right" :rules="ruleValidate" :label-width="130">
                <FormItem label="分子公司" prop="district">
                    <Select v-model="newAccount.district" style="width:200px">
                        <Option v-for="item in districts" :value="item.name" :key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="省" prop="province" :label-width="100">
                    <!-- <Input v-model="newAccount.province"></Input> -->
                    <Select v-model="newAccount.province" filterable :clearable="true" style="width:150px" @on-change="getCitys">
                        <Option v-for="item in provinces" :value="item.areaname" :key="item.id" >{{item.areaname}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="市" prop="city" :label-width="100">
                    <Input v-model="newAccount.city" v-show="!citys.length"></Input>
                    <Select v-model="newAccount.city" filterable :clearable="true" ref="citys" v-show="citys.length">
                        <Option v-for="item in citys" :value="item.areaname" :key="item.id">{{item.areaname}}</Option>
                    </Select>
                </FormItem>
                <br/>
                <FormItem label="业务平台名称:" prop="platform">
                    <Input v-model="newAccount.platform" style="width:300px"></Input>
                </FormItem>
                <FormItem label="业务平台链接地址:" prop="src">
                    <Input v-model="newAccount.src" style="width:310px" placeholder="如：http://www.baidu.com"></Input>
                </FormItem>
                
                <br/>
                <FormItem label="用途:" prop="use" required>
                    <CheckboxGroup v-model="newAccount.use">
                        <Checkbox label="公告发布"></Checkbox>
                        <Checkbox label="用于登录交易中心系统备案与进场交易业务"></Checkbox>
                        <Checkbox label="抽取专家"></Checkbox>
                        <Checkbox label="资料备案"></Checkbox>
                    </CheckboxGroup>
                </FormItem>
                <br/>
                <FormItem label="登陆账号:" prop="account"  required>
                    <Input v-model="newAccount.account" style="width:300px"></Input>
                </FormItem>
                <FormItem label="登陆密码:" prop="pwd">
                    <Input v-model="newAccount.pwd" style="width:310px"></Input>
                </FormItem>
                
                <FormItem label="机构KEY数量:" prop="key" required>
                    <Input v-model="newAccount.key" style="width:150px"></Input>
                </FormItem>
                <FormItem label="机构KEY持有人员:" prop="keyPerson">
                    <Input v-model="newAccount.keyPerson" placeholder="具体人员名单:" style="width:460px"></Input>
                </FormItem>
                <FormItem label="系统登记联系人:" prop="contactPerson">
                    <Input v-model="newAccount.contactPerson" placeholder="具体人员姓名" style="width:300px"></Input>
                </FormItem>
                <FormItem label="联系人电话:" prop="contact">
                    <Input v-model="newAccount.contact" placeholder="手机号或对应分子公司总机" style="width:310px"></Input>
                </FormItem>
                <br/>
                <FormItem label="机构KEY签章功能:" prop="keyUse">
                    <Select v-model="newAccount.keyUse" style="width:100px">
                        <Option value='是'>是</Option>
                        <Option value='否'>否</Option>
                    </Select>
                </FormItem>
                <FormItem label="使用年限:" prop="term">
                    <Input v-model="newAccount.term" style="width:100px"></Input>
                </FormItem>
                <FormItem label="账号更新日期:" prop="date" required>
                    <DatePicker type="date" placeholder="选择日期" v-model="newAccount.date" style="width:270px"></DatePicker>
                </FormItem>
                <FormItem label="备注:" prop="explain">
                    <Input v-model="newAccount.explain" style="width:750px"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancel" type="text">取消</Button><Button @click="ok" type="primary">确认</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import ajax from '@/lib/ajax'
import { debug } from 'util';
export default {
    props:{
        addModal:Boolean,
        newAccount:{
            type:Object,
            default:function(){
                return {
                    district:'',
                    province:'',
                    city:'',
                    // areaname:[],
                    platform:'',
                    src:'',
                    contactPerson:'',
                    contact:'',
                    use:[],
                    account:'',
                    pwd:'',
                    date:'',
                    key:'',
                    keyPerson:'',
                    keyUse:'',
                    term:'',
                    // permission:'',
                    // status:'',
                    explain:''
                }
            }
        },
        mode:{
            type:String,
            default:function(){
                return "1";
            }
        }
    },
    data(){
        return{
            districts:[],
            provinces:[],
            citys:[],
            ifSpin:false,
            ruleValidate:{
                district:[
                    {required:true,message:'请选择地区',triger:'change'}
                ],
                platform:[
                    {required:true,message:'应用业务平台/系统名称不能为空',triger:'blur'}
                ],
                src:[
                    {required:true,message:'应用业务平台/系统链接地址不能为空',triger:'blur'}
                ],
                // contactPerson:[
                //     {required:true,message:'联系人不能为空',triger:'blur'}
                // ],
                // contact:[
                //     {required:true,message:'联系方式不能为空',triger:'blur'}
                // ],
                account:[
                    {required:true,message:'登陆账号不能为空',triger:'blur'}
                ],
                pwd:[
                    {required:true,message:'登陆密码不能为空',triger:'blur'}
                ],
                key:[
                    {required:true,message:'不能为空',triger:'blur'}
                ],
                // keyPerson:[
                //     {required:true,message:'请填写具体保管人员',triger:'blur'}
                // ],
                keyUse:[
                    {required:true,message:'请选择签章功能',triger:'change'}
                ],
                term:[
                    {required:true,message:'使用年限不能为空',triger:'blur'}
                ],
                // permission:[
                //     {required:true,message:'请选择管理权限',triger:'change'}
                // ],
                // status:[
                //     {required:true,message:'请选择状态',triger:'change'}
                // ],
            }
        }
    },
    methods:{
        ok(){
            if(!this.newAccount.use.length){
                this.$Message.error('请选择业务应用平台/系统的用途');
                return;
            }
            if(!this.newAccount.date){
                this.$Message.error('请选择账号更新日期');
                return;
            }
            this.$refs.newAccount.validate(async (valid)=>{
                if(valid){
                    this.ifSpin=true
                    if(this.mode==="1"){ //新增
                        let rep = await ajax.post("http://qy.chinapsp.cn:48884/Doc/add",{
                            "par_id":"root",
                            "docu_type":"account",
                            "district":this.newAccount.district,
                            // "ifContactPerson":this.newAccount.ifContactPerson,
                            // "ifContact":this.newAccount.ifContact,
                            // "ifKeyPerson":this.newAccount.ifKeyPerson,
                            "account":this.newAccount.account,
                            "province":this.newAccount.province,
                            "city":this.newAccount.city,
                            "company":this.newAccount.company,
                            "contact":this.newAccount.contact,
                            "contactPerson":this.newAccount.contactPerson,
                            "date":this.newAccount.date.toLocaleString(),
                            "explain":this.newAccount.explain,
                            "key":this.newAccount.key,
                            "keyPerson":this.newAccount.keyPerson,
                            "keyUse":this.newAccount.keyUse,
                            // "permission":this.newAccount.permission,
                            "platform":this.newAccount.platform,
                            "pwd":this.newAccount.pwd,
                            "src":this.newAccount.src,
                            // "status":this.newAccount.status,
                            "term":this.newAccount.term,
                            "use":this.newAccount.use.join(",")
                        })
                        if(rep.data.success){
                            this.ifSpin=false;
                            this.$emit('close');
                            this.$emit('reflash');
                            this.$refs.newAccount.resetFields();
                            // this.newAccount.ifContactPerson=this.newAccount.ifContact=this.newAccount.ifKeyPerson='是';
                        }
                    }else{ //修改
                        
                        let data = {
                            "docu_id":this.newAccount._id.$oid,
                            "district":this.newAccount.district,
                            // "ifContactPerson":this.newAccount.ifContactPerson,
                            // "ifContact":this.newAccount.ifContact,
                            // "ifKeyPerson":this.newAccount.ifKeyPerson,
                            "account":this.newAccount.account,
                            "province":this.newAccount.province,
                            "city":this.newAccount.city,
                            "company":this.newAccount.company,
                            "contact":this.newAccount.contact,
                            "contactPerson":this.newAccount.contactPerson,
                            "date":this.newAccount.date.toLocaleString(),
                            "explain":this.newAccount.explain,
                            "key":this.newAccount.key,
                            "keyPerson":this.newAccount.keyPerson,
                            "keyUse":this.newAccount.keyUse,
                            // "permission":this.newAccount.permission,
                            "platform":this.newAccount.platform,
                            "pwd":this.newAccount.pwd,
                            "src":this.newAccount.src,
                            // "status":this.newAccount.status,
                            "term":this.newAccount.term,
                            "use":this.newAccount.use.join(",")
                        }
                        // debugger;
                        let rep = await ajax.post("http://qy.chinapsp.cn:48884/Doc/update",data)
                        if(rep.data.success){
                            this.ifSpin=false;
                            this.$emit('close');
                            this.$emit('reflash');
                            this.$refs.newAccount.resetFields();
                            // this.newAccount.ifContactPerson=this.newAccount.ifContact=this.newAccount.ifKeyPerson='是';
                        }
                    }
                }
            });
        },
        cancel(){
            // this.newAccount.ifContactPerson=this.newAccount.ifContact=this.newAccount.ifKeyPerson='是';
            this.$emit('close');
            this.$refs.newAccount.resetFields();
        },
        async getDistricts(){
            let rep = await ajax.get("/api/services/app/CLDistrict/GetList");
            if(rep.data.success){
                this.districts=rep.data.result.items;
            } 
        },
        async getProvinces(){
            let rep = await ajax.get("/api/services/app/Publish/GetArea");
            if(rep.data.success){
                this.provinces=rep.data.result.items;
            }
        },
        async getCitys(){
            this.newAccount.city='';
            let id;
            this.provinces.forEach((obj)=>{
                if(obj.areaname===this.newAccount.province){
                    id=obj.id
                }
            })
            if(id){
                let rep = await ajax.get("/api/services/app/Publish/GetArea?parentId="+id);
                if(rep.data.success){
                    this.citys=rep.data.result.items
                }
            }
        },
        clear(){
            // this.citys=[];
            // this.newAccount.city=this.newAccount.province='';
        }
    },
    created(){
        this.getProvinces();
        this.getDistricts();
    },
    watch:{
        'newAccount.province'(val,oldval){
            if(!val){
                this.newAccount.province=this.newAccount.city='';
                this.citys=[]
            }
        }
    }
}
</script>

<style lang="less">
.add-account{
    // #modal{
        .ivu-modal{
            top:50px;
        }
    // }
}
</style>


